import { Box } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

const ScrollShadow = ({ children, height = 400 }: {
  children: React.ReactNode;
  height?: number | string;
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [top, setTop] = useState(false);
  const [bottom, setBottom] = useState(false);

  const update = () => {
    const el = ref.current;
    if (!el) return;
    const atTop = el.scrollTop <= 0;
    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
    setTop(!atTop);
    setBottom(!atBottom);
  };

  useEffect(() => {
    update();
  }, [children]);

  return (
    <Box
      sx={{
        position: "relative",
        height,
      }}
    >
      {/* Scrollable content */}
      <Box
        ref={ref}
        onScroll={update}
        sx={{
          overflowY: "auto",
          height: "100%",
          backgroundColor: "white",
        }}
      >
        {children}
      </Box>

      {/* Top shadow */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 16,
          pointerEvents: "none",
          opacity: top ? 1 : 0,
          transition: "opacity .18s ease",
          background: "linear-gradient(180deg, rgba(0,0,0,.18), rgba(0,0,0,0))",
        }}
      />

      {/* Bottom shadow */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: 16,
          pointerEvents: "none",
          opacity: bottom ? 1 : 0,
          transition: "opacity .18s ease",
          background: "linear-gradient(0deg, rgba(0,0,0,.18), rgba(0,0,0,0))",
        }}
      />
    </Box>
  );
};

export default ScrollShadow;